import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NatMutualisticaWarningsService } from './warnings/nat-mutualistica.warnings';
import { NaturaMutualisticaFieldValidators } from './validators/natura-mutualistica.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [NaturaMutualisticaFieldValidators, NatMutualisticaWarningsService],
})
export class NaturaMutualisticaFormModule {}
